import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TicketsStatusChange } from '../../models/ticket-status-change';
import { Ticket, UpdateLocation } from '../../models/tickets';
import { TktSiteService } from '../../services/tkt-site.service';
import { SiteType } from '@core/enums/tktSite-enum';
import { firstValueFrom, of } from 'rxjs';
import { PageResult } from '@core/model/pagination/page-result';
import { Site } from '../../models/tkt-site';
import { SortEnumType } from '@generated/queries';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotifyService } from '@core/services/notify.service';
import { FacilityLocationMap } from '../../models/facility-location-map';
import JSZip from 'jszip';
import { GoogleMap } from '@angular/google-maps';

@Component({
  selector: 'app-location',
  standalone: false,
  templateUrl: './location.component.html',
  styleUrl: './location.component.css'
})
export class LocationComponent implements OnInit,AfterViewInit{
  @ViewChild('mapElement') googleMap!: GoogleMap;
  @Input() ticketId: string;
  @Input() ticketLat:string;
  @Input() ticketLng:string;
  @Input() ticket:Ticket
  @Input() isCompleted: boolean;
  @Input() TicketLocationWrite: boolean;
  geoFenceData:FacilityLocationMap[]=[]
  // eslint-disable-next-line
  LoadedPoints:any[]=[];
  locationAndAreaForm: FormGroup;
  isLoading=false
  kmzFile:File=null
  // eslint-disable-next-line
  polygon: any[] = [];
  // eslint-disable-next-line
  polyline: any[] = [];
  // eslint-disable-next-line
  point: any[] = [];
  private polygonMarkers: Map<string, google.maps.marker.AdvancedMarkerElement> = new Map<string, google.maps.marker.AdvancedMarkerElement>();


  locationValues:string[]=[]
  areaValues:string[]=[]
  facilityId:string[]=[]
  allAreas: string[]=[]
  // eslint-disable-next-line
  areaListAll:any[]=[]
  // eslint-disable-next-line
  finalData: { locationPlacemarks: any[]; areaPlacemarks: any[] } = { locationPlacemarks: [], areaPlacemarks: [] };
  @Output() isChangeAnyThing = new EventEmitter<number>();
  @Output() updateTicket = new EventEmitter<boolean>();


  siteSearch: string;
  locValue:string
  stSearch: string[] = [];
  isCallAreaRefresh=false
  selectedSiteType = SiteType.FACILITY;
  siteType = SiteType.LOCATION;
  areaType = SiteType.AREA;
  siteSortInput: { siteName: SortEnumType } = { siteName: SortEnumType.Asc };
  facilitySearch: string;
  center: google.maps.LatLngLiteral = { lat: 0 , lng: 0 }; // Example: San Francisco
  mapHeight = '900px'; // Default height for desktop
  zoom = 17;
  markerPosition: google.maps.LatLngLiteral = { lat: 0 , lng: 0 };
  markerLabel = '';
  markerTitle = '';
  markerOptions: google.maps.marker.AdvancedMarkerElementOptions = {
    gmpDraggable: false, // ✅ replaces draggable
    title: "My Marker",  // ✅ instead of markerTitle
  };

  mapOptions: google.maps.MapOptions = {
    mapTypeId: 'satellite', // Set satellite view
    zoomControl: true, // Enable zoom controls
    scrollwheel: true, // Allow scroll zooming
    disableDoubleClickZoom: false, // Allow double-click zooming
    maxZoom: 50,
    minZoom: 5,

  };
  location: { lat: number; lng: number } | null = null;
  ticketFirstStatus: TicketsStatusChange;

  constructor( public siteService: TktSiteService,
     private fb: FormBuilder,
     private _notifyService: NotifyService,
     private cdr: ChangeDetectorRef){

  }

  async ngOnInit() {
    if (!this.ticket) {
      console.error('Ticket input is missing');
      return;
    }

    const lat = Number(this.ticketLat);
    const lng = Number(this.ticketLng);
    this.center = { lat, lng };
    this.markerPosition = { lat, lng };

    if (this.ticket.facilityId) {
      this.facilityId.push(this.ticket.facilityId);
    }

    this.initForm();

    await this.siteService.fetchSiteByParent(true, this.siteType, 'network-only', this.facilityId);
    await this.loadLocationsAndAreas();
  }

  // ✅ Now safe because map is initialized
  async ngAfterViewInit() {
    if (this.ticket.facilityId) {
      await this.loadGeoFenceData();
    }

    // collect placemark names after data load
    const locationNames = this.finalData.locationPlacemarks.map(loc => this.transformName(loc.placemarkName));
    const areaNames = this.finalData.areaPlacemarks.map(area => area.placemarkName);

    const allPlacemarkNames = [...locationNames, ...areaNames];
    this.setMapForFoldersByNames(allPlacemarkNames, true);
  }


  // Utility function to rename placemarks
  private transformName(name: string): string {
    const regex = /^(.*) Hole (\d+)$/;
    const match = regex.exec(name);

    if (match) {
      let course = match[1].trim();
      const hole = match[2];

      // ✅ Add dash only if course doesn't already end with '-'
      if (!course.endsWith('-')) {
        course += ' -';
      }

      return `${course} Hole ${hole} - Total Area`;
    }

    return name; // if it doesn't match, leave unchanged
  }


  initForm(){
     this.locationAndAreaForm = this.fb.group({
      locationValues: [this.locationValues || []] , // <-- binds initial values
      areaValues:[this.areaValues||[]]
    });
  }


   private sortAreasByAlphaNumeric(names: string[]): string[] {
      return [...names].sort((a, b) => {
        // Extract letters
        const lettersA = a.match(/[a-zA-Z]+/)?.[0].toLowerCase() || '';
        const lettersB = b.match(/[a-zA-Z]+/)?.[0].toLowerCase() || '';

        // 1️⃣ Sort by letters
        if (lettersA !== lettersB) {
          return lettersA.localeCompare(lettersB);
        }

        // Extract numbers
        const numberA = parseInt(a.match(/\d+/)?.[0] || '0', 10);
        const numberB = parseInt(b.match(/\d+/)?.[0] || '0', 10);

        // 2️⃣ Sort by numbers
        return numberA - numberB;
      });
    }


  //Locations which are already saved, load that
  async loadLocationsAndAreas() {
    const locationIds = this.ticket.ticketLocationMap.map(loc => loc.locationId);
    const locationPlacemarkNames = this.ticket.ticketLocationMap.map(
      loc => loc.site.mapPlacemarkName
    );



    // ✅ Fetch areas for the selected locations
    await this.siteService.fetchSiteByParent(
      true,
      this.areaType,
      'network-only',
      locationIds,
      this.siteSortInput
    );

    // ✅ Get response data
    const res = await firstValueFrom(this.siteService.areaChild$);

    // ✅ Build parent-child structure (group by parent location)
    if (res?.data?.length) {
      // Group by parent location
      const groupedAreas = res.data.reduce((acc, area) => {
        const parentName = area.parent?.siteName || 'Unknown'; // Adjust based on API field
        if (!acc[parentName]) acc[parentName] = [];
        acc[parentName].push(area);
        return acc;
      }, {} as Record<string, Site[]>);

      // Get parent names
      const parentNames = Object.keys(groupedAreas);

      // Sort parent names alphanumerically
      const sortedParentNames = this.sortAreasByAlphaNumeric(parentNames);

      // Flatten children based on sorted parent order
      this.areaListAll = sortedParentNames.flatMap(parentName =>
        groupedAreas[parentName].map(child => ({
          id: child.id,
          name: child.siteName, // or child.name depending on API
          parentName: parentName
        }))
      );
    }
    else {
          this.areaListAll = []; // Ensure dropdown is empty if no data
        }

    // ✅ Get saved area IDs and placemark names
    const areaIds = this.ticket.ticketAreaMap.map(area => area.areaId);
    const areaPlacemarkNames = this.ticket.ticketAreaMap.map(
      area => area.area.mapPlacemarkName
    );

    // ✅ Patch form values so dropdown shows selected areas
    this.locationAndAreaForm.patchValue({
      locationValues: locationIds,
      areaValues: areaIds
    });

    // ✅ Build placemark arrays
    const locationPlacemarks = locationIds.map((id, index) => ({
      locId: id,
      placemarkName: locationPlacemarkNames.at(index)
    }));

    const areaPlacemarks = areaIds.map((id, index) => ({
      areaId: id,
      placemarkName: areaPlacemarkNames.at(index)
    }));

    // ✅ Final object in required format
    this.finalData = {
      locationPlacemarks,
      areaPlacemarks
    };

    console.log('Final Data:', this.finalData);
  }






  //Operation on changing the location
  async onChangeLocation(event) {
      if (!event || (Array.isArray(event) && event.length === 0)) {
        this.siteSearch = '';
        this.stSearch = [];
        this.locationAndAreaForm.patchValue({ areaValues: [] });

        // Clear area dropdown data
        this.siteService.areaChild$ = of({
          data: [],
          pageInfo: { hasNextPage: false, hasPreviousPage: false, startCursor: null, endCursor: null },
          totalCount: 0,
          errors: [],
        } as unknown as PageResult<Site>);

        this.areaListAll=[];
        this.updateUI();
        this.isCallAreaRefresh = true;
        this.cdr.detectChanges(); // ✅ Refresh dropdown UI
        return;
      }

      this.stSearch = event;
      this.selectedSiteType = this.areaType;
      this.isCallAreaRefresh = true;

      // ✅ Fetch areas based on selected locations
      await this.siteService.fetchSiteByParent(
        true,
        this.areaType,
        'network-only',
        this.stSearch,
        this.siteSortInput
      );

      this.siteService.checkAreaValues();

      this.allAreas = [];
      const res = await firstValueFrom(this.siteService.areaChild$); // wait for data

      if (res?.data?.length) {
        // ✅ Build parent-child structure
        const groupedAreas = res.data.reduce((acc, area) => {
          const parentName = area.parent?.siteName || 'Unknown'; // adjust to API field
          if (!acc[parentName]) {
            acc[parentName] = [];
          }
          acc[parentName].push(area);
          return acc;
        }, {} as Record<string, Site[]>);

        // ✅ Get parent names and sort them
        const parentNames = Object.keys(groupedAreas);
        const sortedParentNames = this.sortAreasByAlphaNumeric(parentNames);

        // Flatten into list for grouped dropdown using sorted parent order
        this.areaListAll = sortedParentNames.flatMap(parentName =>
          groupedAreas[parentName].map(child => ({
            id: child.id,
            name: child.siteName, // or `child.name` based on your API
            parentName: parentName,
          }))
        );

        // ✅ Keep only valid selected area values
        const currentAreaIds = this.locationAndAreaForm.controls['areaValues'].value || [];
        const validAreaIds = this.areaListAll.map(x => x.id);
        const filteredAreaIds = currentAreaIds.filter(id => validAreaIds.includes(id));
        this.locationAndAreaForm.patchValue({ areaValues: filteredAreaIds.length ? filteredAreaIds : [] });

        this.allAreas = validAreaIds;
      }


      await this.checkSelectedAreaValues();

      this.updateUI();
      this.siteSearch = event;
  }


  async checkSelectedAreaValues(){
    const selectedAreas = this.locationAndAreaForm.value.areaValues || [];
    const validAreas = selectedAreas.filter(areaId => this.allAreas.includes(areaId));
    if (validAreas.length !== selectedAreas.length) {
      this.locationAndAreaForm.patchValue({ areaValues: validAreas });
    }
  }

  async onChangeArea() {
      this.updateUI();
  }

  updateUI() {
    const locationIds = this.locationAndAreaForm.value.locationValues || [];
    const areaIds = this.locationAndAreaForm.value.areaValues || [];

    // Find placemark names for selected locations
    const locationNames = this.finalData.locationPlacemarks
      .filter(loc => locationIds.includes(loc.locId))
      .map(loc => this.transformName(loc.placemarkName));

    // Find placemark names for selected areas
    const areaNames = this.finalData.areaPlacemarks
      .filter(area => areaIds.includes(area.areaId))
      .map(area => area.placemarkName);

    const allPlacemarkNames = [...locationNames, ...areaNames];
    this.setMapForFoldersByNames(allPlacemarkNames, true);
  }



    updateLocationAndArea() {
      this.isLoading=true
      const formValue = this.locationAndAreaForm.value;

      const payload: UpdateLocation = {
        ticketId: this.ticket.id, // assuming you have this.ticket defined
        locationIds: formValue.locationValues.map((loc) => loc.id ?? loc), // handle if objects or ids
        areaIds: formValue.areaValues.map((area) => area.id ?? area)
      };

      console.log('Mapped Payload:', payload);

      this.siteService.updateTicketLocation(payload)
      .then(()=>{
        this._notifyService.success({
          message:"Locations and Areas Updated Successfully"
        })
        this.isChangeAnyThing.emit(1)
         this.updateTicket.emit(true);
      })
      .catch(()=>{
        this._notifyService.error({
          message:"Failed to Update Locations and Areas"
        })
      })
      .finally(()=>{
        this.isLoading=false
      })
    }



    /*Load the geofence data */
     async loadGeoFenceData() {
      this.geoFenceData = [];
      this.LoadedPoints = [];

      const data = await this.siteService.getPaginatedSitesHierarchyByParentId(this.ticket.facilityId);

      if (!data?.length || !data[0].attachment) {
        return;
      }

      // Start async file load but don’t block rest of processing
      await this.FromURL(data[0].attachment.path);

      const parent = data[0];

      const processSite = (site: Site, parentId: string, siteId?: string, areaId?: string) => {
        if (!site.mapPlacemarkName) return;

        const location = new FacilityLocationMap();
        location.businessId = parent.businessId;
        location.placemarkName = site.mapPlacemarkName;
        location.unitArea = site.areaSqFt;
        location.latitude = site.latitude;
        location.longitude = site.longitude;
        location.siteId = siteId || site.id;
        location.parentID = parentId;
        location.areaId = areaId || null;
        location.ManagerId = site.siteManagerId;

        // Add to main list
        this.geoFenceData.push(location);

        // Valid lat/lng check inline
        const lat = Number(site.latitude);
        const lng = Number(site.longitude);
        if (
          !isNaN(lat) &&
          !isNaN(lng) &&
          lat !== 0 && lng !== 0 &&
          lat >= -90 && lat <= 90 &&
          lng >= -180 && lng <= 180
        ) {
          this.LoadedPoints.push({ lat, long: lng, placemarkName: site.mapPlacemarkName });
        }
      };

      // Process children & grandchildren in one traversal
      for (const child of parent.childSite || []) {
        processSite(child, parent.id);
        for (const grandChild of child.childSite || []) {
          processSite(grandChild, parent.id, child.id, grandChild.id);
        }
      }
    }

      async FromURL(url: string) {
        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error('Failed to fetch KMZ file');

          const arrayBuffer = await response.arrayBuffer();
          // eslint-disable-next-line sonarjs/no-unsafe-unzip
          const zip = await JSZip.loadAsync(arrayBuffer);
          const kmlFileName = Object.keys(zip.files).find((f) => f.endsWith('.kml'));
          if (!kmlFileName) throw new Error("No KML file found inside the KMZ archive.");

          const kmzBlob = new Blob([arrayBuffer], { type: "application/vnd.google-earth.kmz" });
          this.kmzFile = new File([kmzBlob], "file.kmz", { type: "application/vnd.google-earth.kmz" });

          const files = Object.keys(zip.files);
            const safeFile = files.find(f => f.endsWith(".kml"));

            if (!safeFile) {
              throw new Error("No valid KML file found");
            }

            // safely get the file object
            const fileEntry = Object.entries(zip.files).find(([name]) => name === safeFile)?.[1];

            if (!fileEntry) {
              throw new Error("Invalid file access");
            }

            const kmlContent = await fileEntry.async("text");

          this.parseKML(kmlContent);
        } catch (error) {
          this._notifyService.error({
            message: 'Failed to load or parse KMZ file.',
          });
          console.error(error);
        }
      }




    /*Parse the KML content */

      parseKML(kmlContent: string) {
        const parser = new DOMParser();
        const kmlDoc = parser.parseFromString(kmlContent, 'application/xml');
        const bounds = new google.maps.LatLngBounds();

        /** ---- Build quick lookup maps ---- **/
        const styleMap = new Map<string, string>();
        const styleReferences = new Map<string, string>();

        // Extract StyleMap references
        Array.from(kmlDoc.getElementsByTagName('StyleMap')).forEach(sm => {
          const id = sm.getAttribute('id');
          if (!id) return;
          Array.from(sm.getElementsByTagName('Pair')).forEach(pair => {
            if (pair.getElementsByTagName('key')[0]?.textContent?.trim() === 'normal') {
              const styleUrl = pair.getElementsByTagName('styleUrl')[0]?.textContent?.trim();
              if (styleUrl) styleReferences.set(`#${id}`, styleUrl);
            }
          });
        });

        // Extract Styles
        Array.from(kmlDoc.getElementsByTagName('Style')).forEach(style => {
          const id = style.getAttribute('id');
          if (!id) return;
          const colorTag = style.getElementsByTagName('color')[0]?.textContent?.trim();
          styleMap.set(`#${id}`, colorTag ? this.kmlColorToHex(colorTag) : '#0000FF');
        });

        /** ---- Recursively process folders ---- **/
        const processFolder = (folderEl: Element) => {
          const folderName = folderEl.querySelector('name')?.textContent?.trim() || 'Unnamed Folder';
          const folderData = {
            id: this.ticket.facilityId || null,
            name: folderName,
            isOpen: false,
            isChecked: true,
            clearFlag: false,
            children: [],
            siteId: null
          };

          // Direct child folders
          Array.from(folderEl.children).forEach(child => {
            if (child.tagName === 'Folder') folderData.children.push(processFolder(child));
          });

          // Direct child placemarks
          Array.from(folderEl.children).forEach(child => {
            if (child.tagName === 'Placemark') {
              const name = child.querySelector('name')?.textContent?.trim() || 'Unnamed Element';
              const coordsText = child.querySelector('coordinates')?.textContent?.trim();
              if (!coordsText) return;

              // Resolve style
              let styleUrl = child.querySelector('styleUrl')?.textContent?.trim();
              if (styleUrl && styleReferences.has(styleUrl)) styleUrl = styleReferences.get(styleUrl)!;
              const color = styleMap.get(styleUrl || '') || '#0000FF';

              // Parse coordinates
              const coordsArray = coordsText.split(' ').map(coord => {
                const [lng, lat] = coord.split(',').map(Number);
                if (!isNaN(lat) && !isNaN(lng)) {
                  bounds.extend({ lat, lng });
                  return { lat, lng };
                }
                return null;
              }).filter(Boolean);

              if (!coordsArray.length) return;

              // Store overlay data for later rendering
              if (child.querySelector('Polygon')) {
                this.polygon.push({ name, paths: coordsArray, color });
              } else if (child.querySelector('LineString')) {
                this.polyline.push({ name, path: coordsArray, color });
              } else if (child.querySelector('Point')) {
                this.point.push({ name, position: coordsArray[0], color });
              }

              // Add to folder structure
              folderData.children.push({
                name,
                isediting: false,
                isChecked: true,
                clearFlag: false,
                coordinates: coordsArray,
                siteId: null
              });
            }
          });

          return folderData;
        };

        /** ---- Process top-level folders ---- **/
        Array.from(kmlDoc.querySelectorAll('Folder')).forEach(folder => {
          if (folder.parentElement?.tagName === 'kml' || folder.parentElement?.tagName === 'Document') {
            processFolder(folder);
          }
        });

        /** ---- Render overlays in batch ---- **/

        const gMap = this.googleMap.googleMap;

        this.polygon.forEach(poly => {
          const polygon = new google.maps.Polygon({
            paths: poly.paths,
            fillColor: poly.color,
            fillOpacity: 0.5,
            strokeColor: poly.color,
            strokeWeight: 2,
            clickable: true,
            map: gMap
          });
          poly.overlay = polygon;

          google.maps.event.addListener(polygon, 'click', (event) => {
            if (!event.latLng) return;
            if (this.geoFenceData.some(place => place.placemarkName === poly.name)) {
              if (this.polygonMarkers.has(poly.name)) {
                const marker = this.polygonMarkers.get(poly.name);
                  if (marker) {
                    marker.map = null; // removes from map
                  }
              }
              const marker = new google.maps.marker.AdvancedMarkerElement({
                position: event.latLng,
                map: gMap,
                title: `Marker in ${poly.name}`
              });
              this.polygonMarkers.set(poly.name, marker);
              this.addPointLatlong(poly.name, event.latLng.lat().toString(), event.latLng.lng().toString());
            }
          });
        });

        this.polyline.forEach(line => {
          line.overlay = new google.maps.Polyline({
            path: line.path,
            strokeColor: line.color,
            strokeOpacity: 1.0,
            strokeWeight: 2,
            map: gMap
          });
        });

        this.point.forEach(pt => {
          pt.overlay = new google.maps.marker.AdvancedMarkerElement({
            position: pt.position,
            title: pt.name,
            map: gMap
          });
        });

        /** ---- Fit bounds once ---- **/
        if (!bounds.isEmpty()) gMap.fitBounds(bounds);

        /** ---- Load preset points ---- **/
        this.LoadedPoints.forEach(data => {
          const marker = new google.maps.marker.AdvancedMarkerElement({
            position: { lat: data.lat, lng: data.long },
            map: gMap
          });
          this.polygonMarkers.set(data.placemarkName, marker);
        });
    }


       kmlColorToHex(kmlColor: string): string {
          if (!kmlColor || kmlColor.length !== 8) return '#0000FF'; // Default Blue

          const blue = kmlColor.substring(2, 4);
          const green = kmlColor.substring(4, 6);
          const red = kmlColor.substring(6, 8);

          return `#${red}${green}${blue}`; // Convert ABGR → RGB format
        }



        addPointLatlong(name: string, lat: string, lng: string) {

              this.geoFenceData.forEach((place) => {
                if (place.placemarkName === name) {
                  place.latitude= lat.substring(0,10);
                  place.longitude = lng.substring(0,10);
                }
              });
        }


    /*Hide and show of the kmz location in Kmz file */

    // 🔹 Updated function
    setMapForFoldersByNames(placemarkNames: string[], isChecked: boolean) {
        const bounds = new google.maps.LatLngBounds();

        const allOverlays = [...this.polygon, ...this.polyline, ...this.point];

        for (const overlay of allOverlays) {
          if (!overlay.overlay) continue;

          // ✅ Reset first: hide everything if not in placemarkNames
          const show = placemarkNames.includes(overlay.name) && isChecked;
          overlay.overlay.setMap(show ? this.googleMap.googleMap : null);

          if (show) {
            if (overlay.overlay.getPath) {
              overlay.overlay.getPath().forEach((latLng: google.maps.LatLng) =>
                bounds.extend(latLng)
              );
            } else if (overlay.overlay.getPosition) {
              bounds.extend(overlay.overlay.getPosition());
            }
    }
  }

  if (!bounds.isEmpty()) {
    this.googleMap.googleMap.fitBounds(bounds);
    this.googleMap.googleMap.setZoom(
      Math.min(this.googleMap.googleMap.getZoom(), 19)
    );
  }
    }



}
